var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18"}},_vm.$listeners),[_c('path',{attrs:{"d":"M0 7.5h18v3H0v-3z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }